'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './myaccount.routes';

export class MyaccountComponent {
  /*@ngInject*/
  constructor(navService, $scope, userService, $timeout, $state, baseConfigService, $http) {
    this.navService = navService;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$state = $state;
    this.userService = userService;
    this.baseConfigService = baseConfigService;
    this.$http = $http;
    this.$scope.updateUserP = {};
    
   
  }

  $onInit(){
    
    this.$timeout(() => {
      this.userService.getCurrentUser()
        .then(response => {
          console.log(response);
          this.$scope.currentUser = response.data;
          this.userService.setCurrentUser(response.data);
          this.navService.getPage();
          
          // Get the first letter of the user's name 
          const userName = this.$scope.currentUser.firstname || ""; 
          this.$scope.avatarLetter = userName.charAt(0).toUpperCase();  // Get the first letter and capitalize it
    
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            this.$state.go('login');
          }
        })
    }, 1000);
    
  }

  /**
   * Updates a single user
   * Service: userService (app/components/services/users)
   * @param {*} id (id of user to be updated)
   */
  updateUser() {
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();
    console.log(this.$scope.currentUser)
    var updateData = this.$scope.currentUser;
    this.$scope.saving = true;

    this.$http
      .post(`${adminBaseURL}/users/update`, updateData)
      .then((responseReport) => {
        console.log(responseReport);
        this.$scope.saving = false;
      })
      .catch((err) => {
        console.log(err);
        this.$scope.saving = false;
        if (err.response === 403) {
          this.$state.go('/login');
        }
      });
  }

    /**
 * Updates a single user
 * Service: userService (app/components/services/users)
 * @param {*} id (id of user to be updated)
 */
    updateUserPwd() {
      console.log(this.$scope.updateUserP);
      console.log(this.$scope.confirmPassword);
  
      // Check if the new password and confirm password match
      if (this.$scope.updateUserP.newPassword !== this.$scope.updateUserP.confirmPassword) {
        return;  // Stop the function if passwords don't match
      }

      this.$scope.saving = true;
      var adminBaseURL = this.baseConfigService.getAdminBaseURL();
      console.log(this.$scope.currentUser)
      var updateData = {
        uid: this.$scope.currentUser.id,
        newPassword: this.$scope.updateUserP.newPassword
      };
  
      this.$http
        .post(`${adminBaseURL}/users/update-pwd`, updateData)
        .then((responseReport) => {
          console.log(responseReport);
          this.$scope.updateUserP = {};
          this.$scope.saving = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response === 403) {
            this.$state.go('/login');
          }
        });
    }
  
}

export default angular.module('appApp.myaccount', [uiRouter])
  .config(routes)
  .component('myaccount', {
    template: require('./myaccount.html'),
    controller: MyaccountComponent,
    controllerAs: 'myaccountCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/myaccount/myaccount.component.js